export type HomeSection =
  | 'feed'
  | 'requests'
  | 'mail'
  | 'activity'
  | 'random'
  | 'friends-of-friends'
  | 'new'
  | 'people-like-you';

export type SkyspaceRoute =
  | { type: 'profile'; handle: string; canonicalize: boolean }
  | {
      type: 'home';
      section: HomeSection;
    }
  | {
      type: 'search';
      query: string;
      onlyInterests: boolean;
      searchType: 'skyspace' | 'users';
    }
  | { type: 'oauth-callback' };

export function parseLegacyRoute(search: string, hash = ''): SkyspaceRoute {
  const query = String(search || '').replace(/^\?/, '');
  const params = new URLSearchParams(query);

  if (params.has('home')) {
    const requested = params.get('home');
    const sections = new Set<HomeSection>([
      'feed',
      'requests',
      'mail',
      'activity',
      'random',
      'friends-of-friends',
      'new',
      'people-like-you',
    ]);
    return {
      type: 'home',
      section: sections.has(requested as HomeSection) ? requested as HomeSection : 'feed',
    };
  }
  if (params.has('search')) {
    return {
      type: 'search',
      query: params.get('search')?.trim() || '',
      onlyInterests: params.get('onlyInterests') === 'true',
      searchType: params.get('searchType') === 'users' ? 'users' : 'skyspace',
    };
  }
  if (!query && hash.includes('code=')) {
    return { type: 'oauth-callback' };
  }

  let handle = params.has('profile') ? params.get('profile') || '' : query;
  try {
    handle = decodeURIComponent(handle).trim();
  } catch {
    handle = handle.trim();
  }

  return {
    type: 'profile',
    handle: handle || 'skyspace.me',
    canonicalize: handle === '',
  };
}

export function profileSearch(handle: string): string {
  return `?${encodeURIComponent(handle)}`;
}

export function searchSearch(
  query: string,
  searchType: 'skyspace' | 'users' = 'skyspace',
): string {
  return `?search=${encodeURIComponent(query)}${searchType === 'users' ? '&searchType=users' : ''}`;
}

export function homeSearch(section = 'feed'): string {
  return `?home=${encodeURIComponent(section)}`;
}
